#import "../fragments/import2-status-fragment.graphql"

query GetImport2ImportStatus($originId: Int!) {
    import2Import(id: $originId) {
        ...Import2StatusFragment
    }
}
